import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import Glyphicon from '../Glyphicon/index.js';
import Text from '../Text/index.js';
const renderStar = _ref => {
  let {
    index,
    percent,
    color
  } = _ref;
  const iconContainerStyle = {
    display: 'inline-block',
    position: 'absolute',
    overflow: 'hidden',
    top: 0,
    left: 0,
    width: `${percent}%`
  };
  const style = {
    display: 'inline-block',
    position: 'relative'
  };
  const starStyle = {
    fontSize: '1em'
  };
  const starStyleWithColor = {
    fontSize: '1em',
    color
  };
  return /*#__PURE__*/_jsx("span", {
    style: style
  }, index, /*#__PURE__*/_jsx(Glyphicon, {
    style: starStyle,
    glyph: "star",
    className: "text-gray-light"
  }), /*#__PURE__*/_jsx("span", {
    style: iconContainerStyle
  }, void 0, /*#__PURE__*/_jsx(Glyphicon, {
    style: starStyleWithColor,
    glyph: "star"
  })));
};
const renderSingleStar = function (value, color) {
  if (value === void 0) {
    value = 0;
  }
  const decimalValue = Number.parseFloat(value).toFixed(1);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx(Glyphicon, {
    glyph: "star",
    className: "margin-right-1",
    style: {
      color
    }
  }), /*#__PURE__*/_jsx("span", {
    className: "text-bold text-subdued"
  }, void 0, decimalValue));
};
const renderMultipleStars = function (value, maxValue, color, showRating) {
  if (value === void 0) {
    value = 0;
  }
  if (maxValue === void 0) {
    maxValue = 5;
  }
  if (color === void 0) {
    color = '#cfd4da';
  }
  if (showRating === void 0) {
    showRating = false;
  }
  const fullStars = Math.floor(value);
  const renderAllStars = Array(maxValue).fill({}).map((star, index) => {
    let percent;
    // Calculate each symbol's fullness percentage
    if (index - fullStars < 0) {
      percent = 100;
    } else if (index - fullStars === 0) {
      percent = (value - index) * 100;
    } else {
      percent = 0;
    }
    return renderStar({
      index,
      percent,
      color
    });
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderAllStars, showRating && /*#__PURE__*/_jsx(Text, {
    weight: "bold",
    className: "margin-left-2"
  }, void 0, Number(value).toFixed(1)));
};

/**
 * StarRating generates a read-only rating component that will display a rating as a percentage of active stars.
 *
 */
function StarRating(_ref2) {
  let {
    className,
    value = 0,
    maxValue = 5,
    uiContext = 'five-stars',
    color = '#e85b00',
    showRating = false,
    ...rest
  } = _ref2;
  const rootClassName = clsx('display-inline-block', className);
  const renderedStarRating = uiContext === 'single-star' ? renderSingleStar(value, color) : renderMultipleStars(value, maxValue, color, showRating);
  return /*#__PURE__*/React.createElement("span", Object.assign({
    "data-cmp": "starRating",
    className: rootClassName
  }, rest), renderedStarRating);
}
export default StarRating;